/**
 * The decisions behind the OAuth sign-in and consent page (WEB-7106) that don't need React, kept here
 * so they can be tested.
 */

// The note under the scopes when the user's plan doesn't cover what the app asked for. Services works out
// what's missing (plan.notCovered); this only words it. Keep it in step with the subscription_required tool
// error and the AI-assistants help page (WEB-7122), which say the same thing.
export const planNote = plan => {
  if (!plan || !plan.notCovered || plan.notCovered.length === 0) return null

  if (plan.notCovered.includes('hunt_data')) {
    return plan.isPro
      ? 'Your plan includes regulations, maps and saving waypoints. Draw odds and harvest data need a plan with hunt data, such as the Pro bundle or Hunt Research.'
      : 'Your free plan includes regulations, maps and saving waypoints. Draw odds and harvest data need BaseMap Pro.'
  }

  return 'Some of what this app asked for isn\'t included in your plan.'
}

/**
 * Services builds the URL the browser goes to next; web never builds the redirect or touches the code.
 * It must lead back to the services host (/connect/authorize), so anything else - another host, or a
 * javascript: URL - is refused rather than followed.
 */
export const isSafeContinueUrl = (continueUrl, apiUri) => {
  try {
    const target = new URL(continueUrl)
    const api = new URL(apiUri)
    return (target.protocol === 'https:' || target.protocol === 'http:') && target.origin === api.origin
  } catch (e) {
    return false
  }
}

/**
 * What to do when services answers 401 to the consent calls (WEB-7128). The route shows this page whenever a
 * token is stored, even an expired one, and a 401 has no body, so it must never read as "request not found".
 * Refresh the session once; after that, or with no refresh token, sign out, which shows <Login /> at this same
 * URL so ?oauthRequest= survives and the user comes back to the same request.
 */
export const UNAUTHORIZED = { REFRESH: 'refresh', SIGN_IN: 'sign_in' }

export const onUnauthorized = ({ refreshTried, hasRefreshToken }) =>
  hasRefreshToken && !refreshTried ? UNAUTHORIZED.REFRESH : UNAUTHORIZED.SIGN_IN
